/**
 * @name EnglishTranslations
 * @description Traducciones en inglés
 */

export const EnglishTranslations = {
  // *************************************
  // GenericMessages                    
  // *************************************
  GenericMessages: {
    es: 'Español',
    en: 'English',
    pt: 'Português',
    app: 'Application',
    apps: 'Applications',
    sidebar: 'Side bar',
    loading: 'Loading',
    company: 'Company',
    rows: 'Rows',
    columns: 'Columns',
    photo: 'Photo',
    name: 'Name',
    names: 'Names',
    lastName: 'Last name',
    lastNames: 'Last names',
    job: 'Job',
    jobs: 'Jobs',
    area: 'Area',
    areas: 'Areas',
    branch: 'Branch',
    branches: 'Branches',
    supervisor: 'Supervisor',
    supervisors: 'Supervisors',
    level: 'Level',
    levels: 'Levels',
    levelDescription: 'Level description',
    competence: 'Competence',
    competencies: 'Competencies',
    gender: 'Gender',
    age: 'Age',
    male: 'Male',
    female: 'Female',
    scale: 'Scale',
    day: 'Day',
    days: 'Days',
    week: 'Week',
    weeks: 'Weeks',
    month: 'Month',
    months: 'Months',
    year: 'Year',
    years: 'Years',
    daily: 'Daily',
    weekly: 'Weekly',
    biweekly: 'Biweekly',
    monthly: 'Monthly',
    bimonthly: 'Bimonthly',
    quarterly: 'Quarterly',
    biyearly: 'Biyearly',
    annually: 'Annually',
    date: 'Date',
    dates: 'Dates',
    birthDate: 'Birth date',
    startDate: 'Start date',
    endDate: 'End date',
    dueDate: 'Due date',
    commitmentDate: 'Commitment date',
    creationDate: 'Creation date',
    expirationDate: 'Expiration date',
    registrationDate: 'Registration date',
    lastUpdateDate: 'Last update date',
    lastUpdate: 'Last update',
    startTime: 'Start time',
    endTime: 'End time',
    start: 'Start',
    end: 'End',
    read: 'Read',
    unread: 'Unread',
    clear: 'Clear',
    open: 'Open',
    note: 'Note',
    step: 'Step',
    data: 'Data',
    email: 'Email',
    academicLevel: 'Academic level',
    phone: 'Phone',
    civilStatus: 'Civil status',
    seniority: 'Seniority',
    employee: 'Employee',
    employees: 'Employees',
    employeeCode: 'Employee code',
    employeeStatus: 'Employee status',
    employeesOf: 'Employees of',
    backup: 'Backup',
    backupOf: 'Backup of',
    option: 'Option',
    options: 'Options',
    seeOptions: 'More options',
    conversations: 'Conversations',
    survey: 'Survey',
    agenda: 'Schedule',
    catcher: 'Catcher',
    admin: 'Administrator',
    adminOf: 'Administration of',
    of: 'of',
    to: 'to',
    or: 'or',
    and: 'y',
    toDate: 'to',
    from: 'From',
    until: 'Until',
    user: 'User',
    users: 'Users',
    userExternal: 'External user',
    team: 'Team',
    welcome: 'Welcome!',
    welcomeTalentry: 'Welcome to Talentry',
    hello: 'Hi',
    niceToHaveYouBack: 'It\'s nice to have you back in Talentry.',
    nextDelivery: 'Next delivery',
    nextDeliveryDate: 'Next delivery date',
    earringsToRecognize: 'Earrings to recognize',
    pendingToRedeem: 'Pending to redeem',
    goTalentry: 'Go to Talentry',
    error: 'Error',
    errros: 'Errors',
    noErrors: 'No errors found',
    noResults: 'No results found',
    noResultsFoundSelectedFilters: 'No results found with selected filters',
    errorContactAdmin: 'Something went wrong, contact your administrator.',
    userBlockedContactAdmin: 'User blocked, please contact the administrator.',
    languageUpdated: 'The language was updated correctly.',
    responsibilities: 'Responsibilities',
    respProgressTab: 'Responsibilities progress',
    free: 'Free',
    everybody: 'Everybody',
    nobody: 'Nobody',
    none: 'None',
    nonee: 'None',
    equal: 'Equal',
    notEqual: 'Not equal',
    all: 'All',
    seeAll: 'See all',
    seeDetail: 'See detail',
    seeDetails: 'See details',
    seeMore: 'See more',
    copy: 'Copy',
    search: 'Search',
    percentage: 'Percentage',
    average: 'Average',
    current: 'Current',
    reply: 'Reply',
    progress: 'Progress',
    example: 'Example',
    examples: 'Examples',
    duration: 'Duration',
    archive: 'Archive',
    archived: 'Archived',
    onTime: 'On time',
    late: 'Late',
    total: 'Total',
    min: 'Minimum',
    max: 'Maximum',
    chars: 'Chars',
    weight: 'Weight',
    sum: 'Sum',
    status: 'Status',
    detail: 'Detail',
    details: 'Details',
    concept: 'Concept',
    description: 'Description',
    localization: 'Localization',
    location: 'Location',
    address: 'Address',
    city: 'City',
    state: 'State',
    country: 'Country',
    private: 'Private',
    comment: 'Comment',
    comments: 'Comments',
    seeComment: 'See comment',
    sendComment: 'Send comment',
    confirmDeleteComment: 'Are you sure to delete your comment?',
    totalOfComments: 'Total comments',
    filter: 'Filter',
    filters: 'Filters',
    filtered: 'Filtered',
    byFilters: 'By filters',
    show: 'Show',
    showing: 'Showing',
    register: 'Register',
    registers: 'Registers',
    totalItems: 'Total items',
    add: 'Add',
    edit: 'Edit',
    delete: 'Delete',
    deleted: 'Deleted',
    select: 'Select',
    selectAll: 'Select all',
    unselect: 'Unselect',
    unselectAll: 'Unselect all',
    unselectSelected: 'Unselect selected',
    selected: 'Selected',
    selecteds: 'Selected',
    selectEmployees: 'Select employees',
    selectedEmployees: 'Selected employees',
    item: 'Item',
    items: 'Items',
    noMatches: 'No matches found',
    mandatory: 'Mandatory',
    attachedImage: 'Attached image',
    attachedFile: 'Attached file',
    restore: 'Restore',
    undo: 'Undo',
    export: 'Export',
    import: 'Import',
    download: 'Download',
    unableToDownload: 'Unable to download',
    successfulDownload: 'The download was successful',
    unfindFiles: 'No files were found to download',
    timeWarning: 'The download could take a few minutes',
    nextPage: 'Next page',
    previousPage: 'Previous page',
    sendToAuth: 'Send to authorization',
    back: 'Back',
    next: 'Next',
    exit: 'Exit',
    history: 'History',
    historical: 'Historical',
    pendingPayment: 'Pending payment',
    paymentWarning: 'Payment due warning',
    noLicense: 'Your cloud licensing expires, to avoid any suspension please contact your Talentry administrator.'
  },
  FormatDates: {
    short: 'MM/DD/YYYY',
    long: 'LL',
    birthday: 'MM/DD',
    shortDate: '{{date, MM/DD/YYYYY}}',
    invalidDate: 'Please enter a valid date',
    invalidMinDate: 'Please enter a valid date. Date should not be before minimal date',
    invalidMaxDate: 'Please enter a valid date. Date should not be after the maximum date'
  },
  StatusText: {
    yes: 'Yes',
    not: 'No',
    true: 'True',
    false: 'False',
    active: 'Active',
    inactive: 'Inactive',
    toBeApproved: 'To be approved',
    approved: 'Approved',
    rejected: 'Rejected',
    notConcluded: 'Not concluded',
    concluded: 'Concluded',
    inRevision: 'In Revision',
    awaiting: 'Awaiting',
    pending: 'Pending'
  },
  DialogConfirm: {
    approve: 'Approve',
    authorize: 'Authorize',
    save: 'Save',
    send: 'Send',
    accept: 'Accept',
    confirm: 'Confirm',
    continue: 'Continue',
    cancel: 'Cancel',
    close: 'Close',
    reject: 'Reject',
    remove: 'Remove',
    understood: 'Understood',
    finish: 'Finish'
  },
  HttpResponse: {
    error: 'Error!',
    success: 'Success!',
    unauthorized: 'Unauthorized method. Error 405',
    somethingWentWrong: 'Something unexpected happened, please try again.',
    badRequest: 'Check all fields.'
  },
  FormsGeneralTexts: {
    required: 'Required',
    optional: 'Optional',
    range: 'The allowed range is between',
    rangeLength: 'The character limit is between',
    and: 'and',
    min2Chars: 'Must contain 2 characters minimum',
    min3Chars: 'Must contain 3 characters minimum',
    min4Chars: 'Must contain 4 characters minimum',
    min8Chars: 'Must contain 8 characters minimum',
    max20Chars: 'Must contain 20 characters maximum',
    max25Chars: 'Must contain 25 characters maximum',
    max100Chars: 'Must contain 100 characters maximum',
    max250Chars: 'Must contain 250 characters maximum',
    max500Chars: 'Must contain 500 characters maximum',
    oneSymbol: 'Must contain at least a symbol',
    oneDigit: 'Must contain at least a digit',
    oneCapitalLetter: 'Must contain at least a capitalized letter',
    oneLowerLetter: 'Must contain at least one lowercase',
    onlyDigits: 'Must contain only 0-9 digits',
    valueCannotBeEqual: 'The value cannot be equal to',
    notMultipleSpaces: 'Must not contain multiple spaces'
  },
  // *************************************
  // Time                            
  // *************************************
  Time: {
    hour: 'Hour',
    hours: 'Hours',
    minute: 'Minute',
    minutes: 'Minutes',
    second: 'Second',
    seconds: 'Seconds'
  },
  // *************************************
  // WeekDays                           
  // *************************************
  WeekDays: {
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday'
  },
  WeekDaysShort: {
    monday: 'Mon',
    tuesday: 'Tue',
    wednesday: 'Wed',
    thursday: 'Thu',
    friday: 'Fri',
    saturday: 'Sat',
    sunday: 'Sun'
  },
  // *************************************
  // Months                            
  // *************************************
  Months: {
    jan: 'January',
    feb: 'February',
    mar: 'March',
    apr: 'April',
    may: 'May',
    jun: 'June',
    jul: 'July',
    aug: 'August',
    sep: 'September',
    oct: 'October',
    nov: 'November',
    dec: 'December',
  },
  MonthsShort: {
    jan: 'Jan',
    feb: 'Feb',
    mar: 'Mar',
    apr: 'Apr',
    may: 'May',
    jun: 'Jun',
    jul: 'Jul',
    aug: 'Aug',
    sep: 'Sep',
    oct: 'Oct',
    nov: 'Nov',
    dec: 'Ded'
  },
  // *************************************
  // Applications                     
  // *************************************
  Applications: {
    sysAdmin: 'sysAdmin',
    settings: 'Settings',
    management: 'Management',
    acknowledgements: 'Acknowledgements',
    indicators: 'Indicators',
    indicatorsAccum: 'Accumulated Indicators',
    evaluations: 'Evaluations',
    communication: 'Communication',
    academy: 'Academy',
    developmentPlan: 'Development Plan'
  },
  // *************************************
  // Reports                            
  // *************************************
  Report: {
    report: 'Report',
    reports: 'Reports',
    columns: 'Columns',
    export: 'Export',
    exportToPNG: 'Export to PNG',
    exportToJPG: 'Export to JPG',
    exportToCsv: 'Export to CSV',
    exportToPdf: 'Exportar to PDF',
    exportToExcel: 'Exportar to Excel',
    exportAllToExcel: 'Export all to Excel',
    exportFiltetredToExcel: 'Export filtered to Excel',
    selectAReport: 'Select a report.',
    selectExportOptions: 'Select the option you want to export.',
    selectColumnsToShow: 'Select the columns you want to show or hide.'
  },
  // *************************************
  // Log In                             
  // *************************************
  Login: {
    sessionStart: 'Start session',
    keepSess: 'Keep session open',
    rememberDevice: 'Remember this device',
    rememberDeviceHelp: 'Skip verification in this browser for the allowed time.',
    enterLogIn: 'Enter',
    twoFactorTitle: 'Two-step verification',
    twoFactorPending: 'Your account requires an additional verification to continue.',
    twoFactorNextStep: 'In the next step you will be able to enter your verification code.',
    twoFactorSentTo: 'The code will be sent to the registered email:',
    twoFactorChallengeId: 'Challenge identifier',
    backToCredentials: 'Back to credentials',
    twoFactorCode: 'Verification code',
    twoFactorCodeHelp: 'Enter the 6-digit code you received by email.',
    twoFactorCodeRequired: 'The code is required.',
    twoFactorCodeInvalid: 'Enter a valid 6-digit code.',
    twoFactorVerify: 'Verify code',
    twoFactorVerifying: 'Verifying...',
    twoFactorResend: 'Resend code',
    twoFactorResending: 'Resending...',
    twoFactorResentSuccess: 'A new verification code was sent.',
    twoFactorVerifyError: 'The code could not be validated. Please try again.',
    twoFactorRemainingAttempts: 'Invalid code. Remaining attempts: {{count}}.',
    twoFactorResendError: 'The code could not be resent. Please try again.',
    twoFactorUnexpectedError: 'Unable to continue with two-step verification.',
    twoFactorExpiresIn: 'The verification code expires in {{time}}.',
    twoFactorResendIn: 'You can resend the code in {{time}}.',
    twoFactorResendReady: 'You can now resend the code.',
    twoFactorExpired: 'The verification code expired. Please sign in again.',
    forgotPassword: 'Forgot your password?',
    userEnterpriseId: 'user.enterpriseId',
    password: 'Password',
    sessionExpired: 'The session has expired.',
    sessionExtended: 'Session successfully extended.',
    sessionExpiringTitle: 'Your session is about to expire!',
    sessionExpiringBody: 'Do you want to continue and extend your session?',
    sessionOf: 'Session of',
    timeRemaining: 'Time remaining',
    closeSession: 'No, close session',
    continueSession: 'Yes, continue session',
    extendingSession: 'Extending session...',
  },
  // *************************************
  // Topbar                             
  // *************************************
  Topbar: {
    home: 'Home',
    goBack: 'Go back',
    notification: 'Notification',
    notifications: 'Notifications',
    notificationsCenter: 'Notification center',
    noNotifications: 'You do not have notifications yet',
    errorNotifications: 'Notifications not loaded',
    markAllAsRead: 'Mark all as read',
    noApps: 'You do not have applications yet',
    adminMenu: 'Administrator menu',
    userMenu: 'User menu',
    setting: 'Settings',
    onboarding: 'Onboarding',
    logout: 'Log out',
    language: 'Language',
  },
  // *************************************
  // ForgotPassword
  // *************************************
  ForgotPass: {
    retrievePassword: 'Retrieve password',
    retrieveMSG: 'If you forgot your password and cannot access your Talentry account, enter your user, you will get an email that will allow you to change your password.',
    retrieve: 'Retrieve',
    procReq: 'Processing your request...',
    invalidUser: 'Please type a valid user name.',
  },
  // *************************************
  // ChangePassword
  // *************************************
  ChangePass: {
    changePass: 'Change your password',
    enterNewPass: 'Enter new password',
    configProcess: 'The configuration process is quick and easy, just create your password to start the adventure',
    passMustMeet: 'Password must meet the following characteristics:',
    mustHaveSymDot: 'Must contain at least one character that is not a digit, i.e: period, comma or dash, etc.',
    mustBetweenDigit0: 'Must contain at least a number between 0 and 9.',
    mustHaveMin8Chars: 'Must contain at least 8 characters.',
    atLeastCap: 'Must contain at least one upper case and one lower case letters.',
    errorToChangePass: 'To change password, it\'s necessary to request a change, afterwards, you will receive an email that you will need to view.',
    previousPass: 'Previous password',
    newPass: 'New password',
    confirmPass: 'Confirm password',
    noPassMatch: 'Passwords don\'t match',
  },
  // *************************************
  // UnlockUser
  // *************************************
  UnlockUser: {
    unlockAccount: 'Unlock account',
    userUnlocked: 'User unlocked!',
    emailExpiredMSG: 'The email has expired, to unlock your account it is necessary that you try to login again, later you will receive a new email to which it is necessary to click.'
  },
  // *************************************
  // Footer
  // *************************************
  Footer: {
    allRightsReserved: 'All rights reserved.',
    noticePrivacy: 'Notice of privacy',
    termsUse: 'Terms of use'
  },
  // *************************************
  // Home                            
  // *************************************
  Home: {
    mission: 'Mission',
    vision: 'Vision',
    values: 'Values',
    goals: 'Goals',
    purpose: 'Purpose',
    principles: 'Principles',
    attributes: 'Brand promise',
    man: 'Men',
    woman: 'Women',
    genderDemographics: 'Gender demographics',
    anniversaries: 'Labor anniversaries',
    anniversariesMonth: 'Labor anniversaries in',
    noAnniversariesFound: 'There are no upcoming labor anniversaries in',
    birthdays: 'Birthdays',
    birthdaysMonth: 'Birthdays in',
    noBirthdaysFound: 'There are no upcoming birthdays in',
    today: 'Today',
    tomorrow: 'Tomorrow',
    youExternalUser: 'You are an external user'
  },
  // *************************************
  // News                           
  // *************************************
  News: {
    new: 'News',
    news: 'News',
    noNews: 'No news',
    seeAllNews: 'See all news',
    iportantAnnouncements: 'Important communications and announcements.',
    all: 'All',
    forAll: 'For all',
    forSupervisor: 'For supervisor',
    title: 'Title',
    subject: 'Subject',
    message: 'Message',
    body: 'Body',
    noPastDates: 'Dates must not be previous to today and the end date must be equal or after to the start date',
    pastDates2: 'The end date must be equal or after the start date',
    newsDeleteSuccess: 'News were deleted correctly',
    newsDeleteError: 'An error occurred',
    addNews: 'Add new',
    editNews: 'Edit new',
    create: 'Create',
    sendNews: 'Send news',
    sendEmail: 'Send email',
    sendNotification: 'Send notification',
    emailSettings: 'Email settings',
    sendSettings: 'Send settings',
  },
  // *************************************
  // Settings
  // *************************************
  Settings: {
    profileConfig: 'Profile configuration',
    personalData: 'Personal data',
  },
  // *************************************
  // Responsibilities
  // *************************************
  Responsibilities: {
    responsibility: 'Responsibility',
    respReport: 'Here you can download the responsibilities of your structure.',
    noRespReport: 'Your structure has no responsibilities yet.',
    structureResponsibilities: 'Structure responsibilities',
    configByEmployee: 'Configure responsibilities by employee',
    seeingMy: 'Viewing my resposibilities',
    seeingOf: 'Viewing responsibilities of',
    selectEmployeeResponsibilities: 'Select an employee to view responsibilities',
    progressByEmployee: 'Progress by employee',
    toBeApproved: 'To be approved',
    revertStatus: 'Revert status',
    revertStatusResp: 'Revert status of responsibilities',
    rejectResp: 'Reject responsibilities',
    whyRevertingStatus: 'Why is the responsibility status being reverted?',
    whyRejectingStatus: 'Why are responsibilities being rejected?',
    minItemsIs: 'The minimum number of items is ',
    maxItemsIs: ', maximum number of elements is ',
    weightTotal: ' and the weight total must be 100',
    minRespIs: 'The minimum quantity of responsibilities is ',
    maxRespIs: ', the maximum ammount of elements is ',
    sumRespWeight: ' and the sum of the weight must be 100',
    areaCode: 'Area code'
  },
  // *************************************
  // UploadFile                    
  // *************************************
  UploadFile: {
    dragAndDrop: 'Drag and drop your file ',
    browseFile: 'or click here to browse file',
    attachFile: 'Attach file',
    attachedImage: 'Attached image',
    attachedFile: 'Attached file',
    downloadFile: 'Download file',
    deleteFile: 'Delete file',
    restoreFile: 'Restore file',
    file: 'File',
    image: 'Image',
    images: 'Images',
    files: 'Files',
    format: 'Format',
    aspectRatio: 'Aspect ratio',
    messageFileRejected: 'File {{fileName}} was rejected. ',
    messageFileTooBig: 'File is too big. Size limit is {{maxSize}} MB. ',
    messageInvalidType: 'File type not supported. ',
    messageAddedFile: 'File {{fileName}} successfully added. ',
    messageRemovedFile: 'File {{fileName}} removed. '
  },
  // *************************************
  // Massive Uploads                    
  // *************************************
  MassiveUploads: {
    downloadBaseFile: 'Download empty base file',
    descriptionError: 'Error description',
    successUpload: 'The bulk upload records were successfully inserted.',
    errorUpload: 'There are errors in some records in the bulk upload.',
    uploadZIPFileMessage: 'The name of each file to be uploaded within the ZIP must be similar to the following example'
  },
  // *************************************
  // Shedule                            
  // *************************************
  Shedule: {
    checkIn: 'Check in',
    departure: 'Departure',
    entryHours: 'Entry hours',
    departureTime: 'Departure time',
    workdays: 'Workdays',
    lookingYouShedule: 'Are you looking at your schedule',
    lookingAtShedule: 'Are you looking at the schedule',
    scheduleSetting: 'Schedule setting',
    scheduleReview: 'Schedule review',
    whyApproveSchedule: 'Why do you approve the schedule?',
    whyRejectingSchedule: 'Why are you rejecting the schedule?',
    rejectSchedule: 'Reject schedule',
    approveSchedule: 'Approve schedule',
  },
  // *************************************
  // Backup                            
  // *************************************
  BackupSettings: {
    assignBackup: 'Assign backup',
    backupAssignments: 'Backup assignments',
    periodApply: 'In what period will it apply?',
    whoYourBackup: 'Who will be your Backup?',
    warningBackup: 'Note: the backup is used only for the Help Center module',
    sureCancelBackup: 'Are you sure you wish to cancel this backup assignment?',
    sureRejectBackup: 'Are you sure you wish to reject this backup assignment?',
    commentCancelBackup: 'Write a comment for the cancellation:',
    commentRejectBackup: 'Write a comment for the employee who selected you:',
    cancelBackup: 'Cancel backup',
    rejectBackup: 'Reject backup',
    infoAlreadyCancel: 'Not possible to cancel this backup assignment because it is already canceled.',
    infoNotPossibleCancel: 'Not possible to cancel this backup assignment.',
    infoNotPossibleCancelStartDate: 'Not possible to cancel this backup assignment because the start date has already passed.',
    infoAlreadyReject: 'Not possible to reject this backup assigment because it is already rejected.',
    infoNotPossibleReject: 'Not possible to reject this backup assignment.',
    infoNotPossibleRejectTomorrow: 'Not possible to reject this backup assignment because the it starts tomorrow.',
    backupLog: 'Backup log',
    catalogResp1: 'Approve/Authorize indicator plans',
    catalogResp2: 'Record indicator results',
    catalogResp3: 'Approve/Authorize accumulated indicators',
    catalogResp4: 'Made an update',
    catalogResp5: 'Attend/Resolve requests in the Help Center',
    requestDescription: 'Request Description',
    aplicantBackup: 'Applicant',
    respToDelegate: 'What responsibilities will you delegate',
    hasNotResp: 'has no responsibilities to delegate',
    respIndicatorsBackup: 'Indicator Responsibilities',
    respHelpDeskBackup: 'Help Center Responsibilities',
    confirmed: 'Confirmed',
    rejected: 'Rejected',
    cancelled: 'Cancelled',
    finalized: 'Finalized',
    createdBackup: 'Created a backup request',
    rejectedBackup: 'Rejected a backup request',
    canceledBackup: 'Canceled a backup request',
    madeBackup: 'Made a backup request',
  },
  // *************************************
  // Request Job                            
  // *************************************
  Request: {
    actualJob: 'Actual job',
    requiredJob: 'Required job',
    jobChange: 'Job change',
    lookingYouRequest: 'You are viewing your requests',
    lookingAtRequest: 'You are viewing requests for',
    requestReview: 'Job change review',
    whyApproveRequest: 'Why do you approve the request?',
    whyRejectingRequest: 'Why are you rejecting the request?',
    rejectRequest: 'Reject request',
    approveRequest: 'Approve request',
    selectnewJob: 'Select your new job',
    warningRequest: 'When changing the position of a collaborator, if the new position has a different duration than their current period, the current period will be truncated and monthly periods will be generated until the beginning of the period corresponding to the position for which the change will be made.',
  },
  // *************************************
  // Notifications                     
  // *************************************
  Notifications: {
    // Gral. Talentry
    adminResponsibilitiesToActive: 'Your administrator changed the status of your responsibilities to active',
    adminResponsibilitiesApproved: 'Your administrator has approved your responsibilities',
    adminResponsibilitiesRejected: 'Your administrator has rejected your responsibilities',
    supervisorResponsibilitiesToActive: 'Your supervisor changed the status of your responsibilities to active',
    supervisorResponsibilitiesApproved: 'Your supervisor has approved your responsibilities',
    supervisorResponsibilitiesRejected: 'Your supervisor has rejected your responsibilities',
    responsibilitiesToApprove: 'You have responsibilities pending to approve of <colaborador>',
    birthdayReminder: 'We inform you that in <dias> day(s) it will be the birthday of <colaborador>',
    evaluationParticipant: 'We inform you that you have been chosen to participate in the evaluation <evaluacion>',
    shedulePendingToSend: 'You have the schedule pending to configure and send for approval.',

    // Indicadores
    assignedResultsManager: 'You have been assigned as the results manager for a <tipoMetrica> in the catalog',
    suggestedIndicators: '<colaborador> has suggested an indicator for you from the catalog',
    periodPlanApproved: 'Your <periodo> plan has been approved by <colaborador>',
    periodPlanRejected: 'Your <periodo> plan has been rejected by <colaborador>',
    periodResultsAuthorized: 'Your <periodo> results has been authorized by <colaborador>',
    periodResultsRejected: 'Your <periodo> results has been rejected by <colaborador>',
    periodPenalizedBySupervisor: 'Your <periodo> has been penalized <porcentaje>% by <colaborador>',
    pendingPlansApprove: 'You have plans pending for approve',
    pendingResultsAuthorize: 'You have results pending for authorize',
    assignedAsBackup: 'You have been assigned as a backup of <colaborador> from <fechaInicio> to <fechaFin>',
    newBackupAssignments: 'There are new backup assignments',
    adminCancelled: 'The administrator has cancelled your backup assignment',
    backupRejected: '<colaborador> has rejected your backup assignment',
    newIndicatorsCatalogAdded: 'Indicators were added to the catalogue',
    backupPeriodEnded: 'Your backup period has ended',
    reminderSendPlan: 'You have until <fecha> to submit your indicators plan of <periodo>',
    reminderSendResults: 'You have until <fecha> to send your results of <periodo>',
    reminderSendPlanPeriods: 'You have until <fecha> to send your indicators plan of <periodo> - <periodoFin>',
    resultIndicatorCaptured: 'The result of an indicator from the catalog that you have in your plan <periodo> has been captured',
    resultModificated: 'The result of an indicator from the catalog that you have in your plan <periodo> has been modified',

    // Reconocimientos
    pendingPrizeRedeptions: 'You have pending prize <premio> redemptions to register',
    assignedKeeperPrizeBranch: 'You have been assigned as the person in charge of prize <premio> at branch <sucursal>',
    assignedKeeperPrize: 'You have been assigned as the person in charge of prize <premio>',
    assignedKeeperDeliveryPrizes: 'You have been assigned as the person in charge of prize delivery',
    acknowledgementsToAcknowledge: 'You have received <reconocimiento> to acknowledge',
    timeToAcknowledge: 'It\'s time to acknowledge!',
    acknowledgementsToRedeem: 'You have been assigned <reconocimiento> to redeem',
    congratulationsAcknowledgements: 'Congratulations! <colaborador> has given you a <reconocimiento>',
    respondAcknowledgements: '<colaborador> has responded to the acknowledgment you gave',
    redeptionCancelled: 'Your redemption for prize <premio> has been cancelled',
    deliveryCancelled: 'Your <reconocimiento> to <colaborador> has been cancelled',
    deliveryReceivedCancelled: 'Your <reconocimiento> received from <colaborador> has been cancelled',

    // Evaluaciones
    chooseFriendsEvaluation: 'Now you can choose your friends in the evaluation <evento>',
    chosenAsFriendEvaluation: 'You have been chosen as a friend of <colaborador> in the evaluation <evento>',
    checkResultsEvaluation: 'Check the results of the evaluation <evento>',
    timeToEvaluate: 'It\'s time to evalute!',
    notFinishEvaluate: 'You\'re not done evaluating yet!',
    makeActionPlan: 'You don\'t have any activities linked to the <evaluacion> assessment yet, we invite you to work on your action plan',

    // Indicadores Acumulados
    accumulatedIndicatorApproved: 'Your accumulated indicator has been approved',
    accumulatedIndicatorRejected: 'Your accumulated indicator has been rejected',
    advancesAccumulatedIndicatorApproved: 'Your advances on your accumulated indicator has been approved',
    advancesAccumulatedIndicatorRejected: 'Your advances on your accumulated indicator has been rejected',
    pendingAccumulatedIndicators: 'You have accumulated indicators of your team pending to review',
    pendingAdvancesAccumulatedIndicators: 'You have advances of accumulated indicators of your team pending to review',

    // Plan de Desarrollo
    activitiesToApprove: 'You have activities pending to approve',
    activityApproved: 'Your activity of type <actividad> has been approved',
    activityRejected: 'Your activity of type <actividad> has been rejected',
    suggestionsActivities: '<colaborador> has made a suggestion for yout development plan',
    suggestionReceived: '<colaborador> has suggested adding an activity of type <actividad> to your development plan',
    makeDevelopmentPlan: 'You don\'t have any activities linked to the <evaluacion> assessment yet, we invite you to work on your development plan',
    haveBeenAssignedTrainingPath: 'You have been assigned to the training path: <path>',
    trainingPathHasBeenModified: 'The training path <path> has been modified',
    commitmentDateCloseExpirationActiviy: 'The commitment date of activity <actividad>, is coming soon',
    endDateCloseExpirationActiviy: 'The end date of activity <actividad>, is coming soon',
    generalDevelopmentPlanProgressReminder: 'Remember to work on your development plan and record progress',
    activityDevelopmentPlanProgressReminder: 'Remember to work on your <actividad> and record progress',

    // Academy
    adminEnrolledToCourse: 'The Academy administrator has enrolled you to the <curso> course',
    adminSentToWaitingList: 'The Academy administrator sent you to the wait list of the <curso> course',
    concludeCourse: 'Congratulations for conclude the <curso> course',
    scheduleModified: 'The schedule for the <curso> course has been modified',
    scheduleCancelled: 'The schedule for the <curso> course has been cancelled',
    requestsToReview: 'You have course requests pending to review',
    requestsToReviewAdmin: 'You have <curso> course requests pending to review in the list of applicants',
    suggestedSchedule: '<colaborador> has suggested you a schedule for the <curso> course',
    requestReplacementCourse: '<colaborador> has requested you to be his replacement in the <curso> course',
    cancelledSubscription: '<colaborador> has cancelled his subscription to the <curso> course',
    courseRequestApproved: 'Your supervisor has authorized your request to the <curso> course',
    courseRequestRejected: 'Your supervisor has rejected your request to the <curso> course',
    replacementCourseAccepted: '<colaborador> has accepted your replacement to the <curso> course',
    replacementCourseRejected: '<colaborador> has rejected your replacement to the <curso> course',
    coursesToReview: 'You have courses requests pending to review',
    replacementCourseExpired: 'We inform you that your course replacement request of <curso> course has expired',
    courseStartDate: 'Your <curso> course starts the <fecha>',
    courseStartDateInstructor: 'Your <curso> course in which you are an instructor starts the <fecha>',
    newAcademyCourses: 'There are new Academy courses!',
    courseExpireDate: 'Your <curso> course expires on <fecha>',
    courseExpired: 'Your <curso> course has expired',
    realesedSpaceEnrolledCourse: 'A space has been released in the <curso> course and you have been registered',
    notSpaceWaitingList: 'Your supervisor has authorized your request to the <curso> course but at the moment there is no quota and you are on the waiting list',
    answerQuestionary: 'We inform you that the course survey <curso> has started. You have until before <fecha> to answer it.',
    courseHaveRegisteredWaiting: 'We inform you that you have been registered for the course <curso>, for which you were on the waiting list. You are now formally enrolled',

    // Comunicación
    startEvent: 'Has started the <tipoEvento> event: <evento>',
    endEvent: 'Has ended the <tipoEvento> event: <evento>',
    assignedToInterview: 'You have been assigned to interview <entrevistado> in the <tipoEvento>: <evento>',
    scheduledConversation: 'Your conversation of the <evento> event has been scheduled for <fecha> at <hora>',
    assignedDelegate: '<colaborador> has assigned you as a delegate of <tipoDelegado> in the <tipoEvento> event: <evento>',
    unassignedDelegate: '<colaborador> has unassigned you as a delegate of <tipoDelegado> in the <tipoEvento> event: <evento>',
    assignedToActivity: '<colaborador> has assigned you as responsible for the activity with the ID: <actividad>',
    acceptedActivity: '<responsable> has accepted the activity with the ID: <actividad>',
    rejectedActivity: '<responsable> has rejected the activity with the ID: <actividad>',
    advanceActivity: '<responsable> has entered an advance to the activity <actividad>',
    haveBeenAddedParticipant: '<colaborador> added you as a participant to the activity with the ID: <actividad>',
    haveBeenRemovedParticipant: '<colaborador> has removed you as a participant from the activity with the ID: <actividad>',
    deletedActivity: '<colaborador> has deleted the activity with the ID: <actividad>',
    concludedActivity: '<responsable> has concluded the activity <actividad>',
    notFinishedActivity: 'We remind you that you have pending activities to conclude',
    remindFinishSurvey: 'We remind you to finish answering the event <tipoEvento>: <evento>',
    remindScheduleConversation: 'We remind you to schedule your conversation with <interviewee> at the event <tipoEvento>: <evento>',

    // Sueldos y Promociones
    postulateApproved: 'Your postulation of <postulado> has been approved by <tercerNivel>',
    postulateRejected: 'Your postulation of <postulado> has been rejected by <tercerNivel>',
    pendingPostulations: 'You have postulations pending to review',
    resultsEvent: 'Check the results of the <evento> event',
    salariesEvent: 'Check the salaries of the <evento> event',
    postulateEmployee: 'Postulate employees for the <evento> event!',
    timeToVote: 'It\'s time to vote in the <evento> event!',

    // Reclutamiento
    requestRejectedManager: 'We inform you that the application of <colaborador> for the job <puesto> was canceled by the committee',
    requestApprovedManager: 'We inform you that the request of <colaborador> for the job <puesto> was confirmed by the committee',
    requestRejectedSupervisor: 'Your application for the <puesto> job was canceled by the committee',
    requestApprovatedSupervisor: 'Your application for the <puesto> job was confirmed by the committee',
    voteDoubt: 'We inform you that a member of the committee cast a vote in doubt on the request of <colaborador> for the <puesto> job',
    requestPendingReview: 'We inform you that you have pending requests to review',
    requestRejected: 'We inform you that your application for the <puesto> job was rejected',
    requestCancelledManager: 'We inform you that the supervisor <colaborador> has canceled his request to the <puesto> job',
    requestCancelledSupervisor: 'Your application to the <puesto> job has been canceled by the manager',
    assignedManager: 'You have been assigned as Request Manager',
    deleteManager: 'Your application manager assignment has ended',
    assignedCommittee: 'You have been assigned as a member of the voting committee',
    deleteCommittee: 'Your assignment as a voting committee member has ended',
    requestConcludedSupervisor: 'Your application for the <puesto> job has been completed by the manager',
    requestApprovated: 'We inform you that your application for the <puesto> job was approved and sent to the committe for review',
    requestVoteCommitte: 'We inform you that a new request has started its vote',

    // Expediente 360
    shedulePending: 'You have pending schedule to approve of <colaborador>',
    sheduleApproved: 'Your supervisor has approved your schedule',
    sheduleRejected: 'Your supervisor has rejected your schedule',
    backupAssigned: '<colaborador> has assigned you as a backup from <fechaInicio> to <fechaFin>',
    cancelledBackup: '<colaborador> has cancelled the backup request',
    rejectedBackup: '<colaborador> has rejected your backup request',
    contractExpiration: 'We inform you that the contract <contrato> of <colaborador> will expire in <dias> days',
    jobRequestPending: 'We inform you that you have pending job change requests to review',
    jobRequestRejected: 'We inform you that your supervisor rejected your request to change your position',
    jobRequestApproved: 'We inform you that your supervisor approved your job change request',
    endBackup: 'The backup period has ended',

    // HelpDesk
    myRequestHasBeenAssigned: 'Your request #<idreporte> has been assigned to <especialista>',
    myRequestHasBeenReassigned: 'Your request #<idreporte> has been reassigned to <especialista>',
    myRequestHasBeenPaused: 'Your request #<idreporte> has been paused to <especialista>',
    myRequestHasBeenCanceled: 'Your request #<idreporte> has been canceled to <especialista>',
    myRequestHasBeenClosed: 'Your request #<idreporte> has been closed to <especialista>',
    addedCommentsMyRequest: '<especialista> added comments to your request #<idreporte>',
    haveBeenAssignedRequest: 'You have been assigned to a new request #<idreporte>',
    haveBeenReassignedRequest: 'You have been reassigned to the request #<idreporte>',
    addedCommentsRequest: 'Comments have been added to the request #<idreporte>',
    requestEvaluated: '<colaborador> has evaluated the attention of the request #<idreporte>',
    requestReopened: 'Your request #<idreporte> has been reopened',
    configNonWorkingDaysMoment: 'It is time to configure the non-working days of your company'
  }
};
